export default __webpack_public_path__ + "static/media/bg-geometry.56ce656d.svg";